// extracted by mini-css-extract-plugin
module.exports = {"background":"Home_background__B2C0N"};